module.exports = "/_next/static/images/miningMob-3e7a4a14c2e7c34c5efa1f7549be6933.png.webp";